export default __webpack_public_path__ + "static/media/16.fe91da48.svg";